import Image from 'next/image';
import type { PointerEvent } from 'react';
import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useGraphField } from '../../components/FinalForm/useGraphField';
import { Tooltip } from '../../components/GraphModal/Tooltip';

const messages = defineMessages({
  boostGuide: {
    defaultMessage: "cochez la fusée pour boster votre message afin qu'il remonte dans le flux",
    id: 'tg7Ewf',
  },
});

export const BoostField: React.FC<{ name: string }> = ({ name }) => {
  const { input } = useGraphField({
    name,
  });
  const boost = !!input.value;
  const { formatMessage } = useIntl();

  const preventDefault = useCallback(
    (e: PointerEvent<HTMLDivElement | HTMLLabelElement>) => e.preventDefault(),
    [],
  );

  const handleChange = useCallback(() => input.onChange(!boost), [boost, input]);

  const imgSrc = boost ? '/img/rocket.png' : '/img/rocket-nb.png';
  return (
    <Tooltip content={formatMessage(messages.boostGuide)}>
      <div
        role="button"
        className="BoostField h-10 w-10 flex justify-center items-center box-content"
        tabIndex={-1}
        onClick={handleChange}
        onPointerDown={preventDefault}
      >
        <Image src={imgSrc} height={20} width={20} className="h-5 w-5" alt="boost" />
      </div>
    </Tooltip>
  );
};
